import React, { useEffect } from 'react'
import { message, Radio, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { baseTiredSettingModel } from '../tiredSettingModel'
import { tiredSettingService, ITiredSettingDetail } from '../tiredSettingService'
import { globalPrompt } from '@/components/message'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, loadData, setSelectedRowKeys } = baseTiredSettingModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const columns: ColumnsType<ITiredSettingDetail> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: '账户',
            width: 120,
            align: 'center',
            dataIndex: 'accountName',
        },
        {
            title: '角色',
            width: 160,
            align: 'center',
            dataIndex: 'type',
        },
        {
            title: '名称',
            width: 160,
            align: 'center',
            dataIndex: 'name',
        },
        {
            title: '检测个数',
            width: 100,
            align: 'center',
            dataIndex: 'num',
        },
        {
            title: '疲劳检测',
            width: 100,
            dataIndex: 'num',
            fixed: 'right',
            align: 'center',
            render: (text, record) => (
                <Radio.Group
                    onChange={(e) => {
                        onChange(e, record)
                    }}
                    value={text}
                >
                    <Radio value={10}>10</Radio>
                    <Radio value={15}>15</Radio>
                    <Radio value={20}>20</Radio>
                </Radio.Group>
            ),
        },
    ]

    const onChange = (e, record: any) => {
        globalPrompt('modal', {
            title: '疲劳检测设置',
            type: 'warning',
            text: '重新设置疲劳检测数量后，需要30天的数据采集期。在数据采集期内只采集数据，所有检测都视为“通过。”',
            okText: '确认',
            onOk: async () => {
                let insertRet = await tiredSettingService.update({
                    id: record.id,
                    num: e.target.value,
                })
                if (insertRet.success) {
                    message.success('设置成功!')
                } else {
                    message.success('设置失败!' + insertRet.retMsg)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    //点击行选高亮
    const onRow = (record: ITiredSettingDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            // rowSelection={{
            //     //全部选中时 (存row[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
            //             : setSelectedRowKeys((origin) => {
            //                 let changeRowId = changeRows.map(item => item.id);
            //                 return origin.filter(item => changeRowId.indexOf(item.id) < 0)
            //             });
            //     },
            //     onSelect: (record, selected, selectedRows) => onRow(record),
            //     selectedRowKeys: selectedRowKeys.map(item => item.id as string)
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}
